import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({name: 'utcdatepipe'})
export class UTCDatePipe implements PipeTransform {  
  transform(value: Date): Date {
    if(value!=null)  
    return moment.utc(value).local().toDate();
    else
     return null;
  }
}